import { render, staticRenderFns } from "./ProductRent.vue?vue&type=template&id=2abc2e8a&scoped=true&"
import script from "./ProductRent.vue?vue&type=script&lang=js&"
export * from "./ProductRent.vue?vue&type=script&lang=js&"
import style0 from "./ProductRent.vue?vue&type=style&index=0&id=2abc2e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc2e8a",
  null
  
)

export default component.exports